import { Link } from 'react-router-dom';

export default function TheoryPage() {
  const theories = [
    {
      id: 'toc',
      title: 'TOC（制約理論）',
      description: '全体の成果は制約で決まる。ボトルネックを特定し、システム全体を最適化する理論',
      icon: 'ri-links-line',
      color: 'from-blue-500 to-blue-600',
      link: '/theory/toc'
    },
    {
      id: 'dbr',
      title: 'DBR（ドラム・バッファ・ロープ）',
      description: 'TOCを実装する運用ルール。制約のリズムに合わせて仕事の流れを制御する',
      icon: 'ri-git-branch-line',
      color: 'from-green-500 to-green-600',
      link: '/theory/dbr'
    },
    {
      id: 3,
      title: 'フロー効率（Flow Efficiency）',
      description: '付加価値時間と待ち時間の比率を最適化し、全体のリードタイムを短縮する理論',
      icon: 'ri-speed-line',
      color: 'from-emerald-500 to-teal-500',
      link: '/theory/flow-efficiency',
    },
  ];

  const theoryItems = [
    { 
      title: 'TOC（制約理論）', 
      path: '/theory/toc',
      description: 'ボトルネックを特定し、システム全体の最適化を図る理論',
      icon: 'ri-focus-3-line',
      color: 'from-amber-500 to-orange-500'
    },
    { 
      title: 'DBR（ドラム・バッファ・ロープ）', 
      path: '/theory/dbr',
      description: 'TOCに基づく生産スケジューリング手法',
      icon: 'ri-rhythm-line',
      color: 'from-rose-500 to-pink-500'
    },
    { 
      title: 'フロー効率（Flow Efficiency）', 
      path: '/theory/flow-efficiency',
      description: '価値を生む時間の割合を最大化する考え方',
      icon: 'ri-flow-chart',
      color: 'from-cyan-500 to-teal-500'
    },
    { 
      title: 'タクト思考（Takt Thinking）', 
      path: '/theory/takt-thinking',
      description: '需要に合わせたリズムで業務を設計する手法',
      icon: 'ri-timer-line',
      color: 'from-violet-500 to-purple-500'
    },
    { 
      title: 'システム思考（全体最適）', 
      path: '/theory/system-thinking',
      description: '部分最適ではなく全体を俯瞰した意思決定',
      icon: 'ri-mind-map',
      color: 'from-blue-500 to-indigo-500'
    },
    { 
      title: 'スイスチーズ・モデル', 
      path: '/theory/swiss-cheese-model',
      description: '多層防御によるエラー防止の考え方',
      icon: 'ri-shield-check-line',
      color: 'from-emerald-500 to-green-500'
    },
    { 
      title: 'リトルの法則', 
      path: '/theory/littles-law',
      description: '待ち行列理論の基本法則',
      icon: 'ri-calculator-line',
      color: 'from-sky-500 to-blue-500'
    },
    { 
      title: 'ハインリッヒの法則', 
      path: '/theory/heinrichs-law',
      description: '1:29:300の事故発生比率の法則',
      icon: 'ri-alert-line',
      color: 'from-red-500 to-rose-500'
    },
    { 
      title: 'ドナベディアン・モデル', 
      path: '/theory/donabedian-model',
      description: '医療の質を構造・過程・結果で評価',
      icon: 'ri-hospital-line',
      color: 'from-teal-500 to-cyan-500'
    },
    { 
      title: 'ピーク・エンドの法則', 
      path: '/theory/peak-end-rule',
      description: '体験の記憶はピークと終わりで決まる',
      icon: 'ri-emotion-happy-line',
      color: 'from-yellow-500 to-amber-500'
    },
    { 
      title: 'ABC分析 × パレート法則', 
      path: '/theory/abc-pareto',
      description: '重要度に基づく優先順位付けの手法',
      icon: 'ri-bar-chart-grouped-line',
      color: 'from-orange-500 to-red-500'
    },
    { 
      title: 'ナッジ理論', 
      path: '/theory/nudge-theory',
      description: '行動を自然に促す仕組みづくり',
      icon: 'ri-hand-coin-line',
      color: 'from-lime-500 to-green-500'
    },
    { 
      title: 'ヤーキーズ・ドットソンの法則', 
      path: '/theory/yerkes-dodson',
      description: 'ストレスとパフォーマンスの逆U字関係',
      icon: 'ri-mental-health-line',
      color: 'from-fuchsia-500 to-pink-500'
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-amber-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center cursor-pointer">
              <div className="w-10 h-10 mr-3 relative">
                <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                  <i className="ri-heart-pulse-fill text-white text-lg"></i>
                </div>
              </div>
              <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                みんなの薬局～Pharmacare～
              </div>
            </Link>
            <nav className="hidden md:flex space-x-8">
              <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
              <Link to="/information" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-amber-500 via-orange-500 to-red-500"></div>
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-72 h-72 bg-white/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-yellow-300/20 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl mb-6">
            <i className="ri-book-2-line text-4xl text-white"></i>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            薬局経営の理論
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto mb-6">
            "偶然うまくいく薬局"から、"再現できる薬局"へ
          </p>
          <p className="text-lg text-white/80 max-w-2xl mx-auto">
            エビデンスに基づいた理論を学び、薬局経営に活かしましょう。<br />
            各理論をクリックして詳細をご覧ください。
          </p>
        </div>
      </section>

      {/* Theory Grid */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">理論一覧</h2>
            <p className="text-gray-600">薬局経営に役立つ13の理論フレームワーク</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {theoryItems.map((item, index) => (
              <Link
                key={index}
                to={item.path}
                className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100"
              >
                <div className={`h-3 bg-gradient-to-r ${item.color}`}></div>
                <div className="p-6">
                  <div className="flex items-start gap-4">
                    <div className={`w-14 h-14 bg-gradient-to-br ${item.color} rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform shadow-lg`}>
                      <i className={`${item.icon} text-2xl text-white`}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-amber-600 transition-colors">
                        {item.title}
                      </h3>
                      <p className="text-sm text-gray-600 leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </div>
                  <div className="mt-4 flex items-center justify-end text-amber-600 font-medium text-sm">
                    <span>詳細を見る</span>
                    <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-amber-50 to-orange-50">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            理論を実践に活かす
          </h2>
          <p className="text-gray-600 mb-8">
            理論を学んだら、チームビルディングや日々の業務改善に活かしましょう。<br />
            PharmaBeastは薬局経営の成功を全力でサポートします。
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/services"
              className="px-8 py-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-lg font-semibold hover:from-amber-600 hover:to-orange-600 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
            >
              サービス一覧を見る
            </Link>
            <Link
              to="/"
              className="px-8 py-3 bg-white text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors border border-gray-200 shadow whitespace-nowrap cursor-pointer"
            >
              トップページに戻る
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">患者さん向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-consultation" className="hover:text-white cursor-pointer">健康相談</Link></li>
                <li><Link to="/self-care" className="hover:text-white cursor-pointer">セルフケア</Link></li>
                <li><Link to="/kampo" className="hover:text-white cursor-pointer">漢方相談</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">薬剤師向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/theory" className="hover:text-white cursor-pointer">理論</Link></li>
                <li><Link to="/sterile-preparation" className="hover:text-white cursor-pointer">無菌調剤</Link></li>
                <li><Link to="/home-care" className="hover:text-white cursor-pointer">在宅医療</Link></li>
                <li><Link to="/dx" className="hover:text-white cursor-pointer">薬局DX</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/official-links" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/contact" className="hover:text-white cursor-pointer">お問い合わせ</Link></li>
                <li><Link to="/privacy-policy" className="hover:text-white cursor-pointer">プライバシーポリシー</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
